export const MANAGE_INFO_REF = 'profile-settings-manage-info';
export const MEMBERS_LIST_ORIGIN = 'members_list';
